import type { FieldConfiguration } from './types';

/**
 * Artificial, locally-injected issue type field configuration.
 *
 * Why this is the only hard-coded field declared here:
 * - The GraphQL `fieldsConfiguration` connection does NOT include an `issuetype` field; nor do Rovo suggestion actions.
 * - The UI, however, needs a stable first column representing the issue type for visual clarity and editing context.
 * - We guarantee it is always present, required, and editable to allow local rendering (`JiraIssueTypeField`) without
 *   relying on backend data availability.
 * - Downstream logic (`buildUniqueFieldsConfiguration`) prepends this field before any dynamically collected fields.
 *
 * If in future the backend supplies an equivalent field, this constant acts as an override ensuring consistent ordering
 * and behavior until a migration removes the hard-coded definition.
 */
export const ISSUE_TYPE_FIELD: FieldConfiguration = {
	__typename: 'JiraIssueTypeField',
	fieldId: 'issuetype',
	type: 'issuetype',
	name: 'Type',
	isEditable: true,
	isRequired: true,
};
